/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const GovernanceType = {
    Internal: 'Internal',
    External: 'External'
} as const;
export type GovernanceType = typeof GovernanceType[keyof typeof GovernanceType];

